import { render, staticRenderFns } from "./MyPatients.vue?vue&type=template&id=5f709a82&scoped=true&"
import script from "./MyPatients.vue?vue&type=script&lang=js&"
export * from "./MyPatients.vue?vue&type=script&lang=js&"
import style0 from "./MyPatients.vue?vue&type=style&index=0&id=5f709a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f709a82",
  null
  
)

export default component.exports